import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Icon } from "app/NativeComponents/common";
import GoogleMapReact from "google-map-react";

import { getMapOptions } from "../Map/MapStyles";

import {
  updateMapLocation,
  setLastLocation,
  dismissMobileKeyboard
} from "app/NativeActions";

import { renderDrawing } from "./Drawing";

import DrawingMapHeader from "app/DealMachineCore/components/DrawingMap/DrawingMapHeader";
import DrawingMapFooter from "app/DealMachineCore/components/DrawingMap/DrawingMapFooter";

const default_lat = 39.97411;
const default_lng = -86.11756;
const default_lat_delta = 0.02;
const default_lng_delta = 0.02;

class DrawMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMapReady: false,
      show_map_options: false,
      update_to_coordinates: {
        latitude: null,
        longitude: null
      },
      map_region_properties: {
        center: {
          //latitude: this.props.user.user_default_lat ? parseFloat(this.props.user.user_default_lat) : default_lat,
          //longitude: this.props.user.user_default_lng ? parseFloat(this.props.user.user_default_lng) : default_lng,
          latitude: props.update_map_location
            ? props.update_map_location.latitude
            : props.last_location
            ? props.last_location.latitude
            : props.user
            ? props.user.user_default_lat
              ? parseFloat(props.user.user_default_lat)
              : default_lat
            : default_lat,
          longitude: props.update_map_location
            ? props.update_map_location.longitude
            : props.last_location
            ? props.last_location.longitude
            : props.user
            ? props.user.user_default_lng
              ? parseFloat(props.user.user_default_lng)
              : default_lng
            : default_lng
        },
        heading: props.last_location ? props.last_location.heading : 0,
        pitch: 0,
        zoom: 16,
        altitude: 0
      },
      last_fetch_location: {
        latitude: props.update_map_location
          ? props.update_map_location.latitude
          : props.last_location
          ? props.last_location.latitude
          : props.user
          ? props.user.user_default_lat
            ? parseFloat(props.user.user_default_lat)
            : default_lat
          : default_lat,
        longitude: props.update_map_location
          ? props.update_map_location.longitude
          : props.update_map_location
          ? props.last_location.longitude
          : props.user
          ? props.user.user_default_lng
            ? parseFloat(props.user.user_default_lng)
            : default_lng
          : default_lng,
        heading: props.update_map_location
          ? props.update_map_location.heading
          : props.last_location
          ? props.last_location.heading
          : 0
      },
      maxZoomOut: 15,
      pin_location: null,
      is_pan_dragging: false,
      is_map_moving: false,
      highlight_array: [],
      current_route_coordinates: [],
      combined_routes: []
    };
  }

  toggleIsPanDraging(toggle) {
    if (this.state.is_pan_dragging != toggle) {
      this.setState({ is_pan_dragging: toggle });
    }
  }

  toggleIsRegionChanging(toggle) {
    if (this.state.is_region_changing != toggle) {
      this.setState({ is_region_changing: toggle });
    }
  }

  componentDidMount() {}

  shouldComponentUpdate(prevProps, prevState) {
    if (
      prevProps.open != this.props.open ||
      prevState.pin_location != this.state.pin_location ||
      prevState.map_region_properties != this.state.map_region_properties ||
      prevProps.is_search_bar_focused != this.props.is_search_bar_focused ||
      prevState.isMapReady != this.state.isMapReady ||
      prevProps.last_location != this.props.last_location ||
      prevProps.update_map_location != this.props.update_map_location ||
      prevProps.is_drawing != this.props.is_drawing ||
      prevProps.drawing_coordinates != this.props.drawing_coordinates ||
      prevProps.expand_map != this.props.expand_map ||
      prevState.reset_render_drawing != this.state.reset_render_drawing
    ) {
      return true;
    }

    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.map_region_properties && this.state.map_region_properties) {
      if (
        this.props.drawing_coordinates != prevProps.drawing_coordinates ||
        this.props.is_drawing != prevProps.is_drawing
      ) {
        renderDrawing(this.state.google_map, this.props.drawing_coordinates);
      }

      if (
        prevState.map_region_properties.center.latitude !=
          this.state.map_region_properties.center.latitude ||
        prevState.map_region_properties.center.longitude !=
          this.state.map_region_properties.center.longitude ||
        prevState.map_region_properties.zoom !=
          this.state.map_region_properties.zoom
      ) {
      }
    }

    if (prevProps.update_map_location == null) {
      if (this.props.update_map_location != null) {
        this.changeMapLocation(this.props.update_map_location);
      }
    } else if (
      this.props.update_map_location &&
      prevProps.update_map_location
    ) {
      if (
        this.props.update_map_location.latitude !=
          prevProps.update_map_location.latitude ||
        this.props.update_map_location.longitude !=
          prevProps.update_map_location.longitude ||
        this.props.update_map_location.heading !=
          prevProps.update_map_location.heading
      ) {
        this.changeMapLocation(this.props.update_map_location);
      }
    }

    if (prevState.isMapReady != this.state.isMapReady) {
      if (this.state.map_region_properties) {
        if (
          this.state.map_region_properties.center.latitude &&
          this.state.map_region_properties.center.longitude
        ) {
        }
      }
    }
  }

  changeMapLocation(location) {
    if (location && !this.state.is_map_moving) {
      if (this.state.google_map) {
        this.state.google_map.setCenter(
          new window.google.maps.LatLng(
            parseFloat(location.latitude),
            parseFloat(location.longitude)
          )
        );
      }
    }
  }

  componentWillUnmount() {}

  onMapReady(map, maps) {
    this.setState({
      isMapReady: true,
      google_map: map
    });

    renderDrawing(map, this.props.drawing_coordinates);
  }

  updatePinLocation(coordinates) {
    this.setState({
      pin_location: coordinates
    });
  }

  renderMapPin(coordinates) {
    if (coordinates) {
      if (coordinates.latitude && coordinates.longitude) {
        return (
          <div
            key={"pin"}
            ref={"pin"}
            style={{
              marginTop: "-10px",
              marginLeft: "-10px"
            }}
            lat={parseFloat(coordinates.latitude)}
            lng={parseFloat(coordinates.longitude)}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <Icon icon="add" size={20} />
          </div>
        );
      }
    }
  }

  zoomToMin() {
    this.setState({
      map_region_properties: {
        ...this.state.map_region_properties,
        zoom: this.state.maxZoomOut
      }
    });
  }

  handleZoomControl(type) {
    var maxZoom = 20;
    var minZoom = 13;

    if (type === "zoom-in" && this.state.map_region_properties.zoom < maxZoom) {
      this.setState({
        map_region_properties: {
          ...this.state.map_region_properties,
          zoom: this.state.map_region_properties.zoom + 1
        }
      });
    } else if (
      type === "zoom-out" &&
      this.state.map_region_properties.zoom > minZoom
    ) {
      this.setState({
        map_region_properties: {
          ...this.state.map_region_properties,
          zoom: this.state.map_region_properties.zoom - 1
        }
      });
    }
  }

  render() {
    if (
      this.state.map_region_properties.center.latitude &&
      this.state.map_region_properties.center.longitude
    ) {
      return (
        <Wrapper
          style={{
            width: this.props.map_width ? this.props.map_width : "100%",
            height: this.props.map_height ? this.props.map_height : 250,
            flex: 1,
            position: "relative"
          }}
        >
          <div
            className="deal-map-container"
            style={{
              flex: 1
            }}
          >
            <GoogleMapReact
              id="dealmachine-draw-map"
              ref="map"
              yesIWantToUseGoogleMapApiInternals={true}
              bootstrapURLKeys={{
                key: "AIzaSyBKxAXFBe8TSxxLFX6jDKxZdTu8-rdv_6s"
              }}
              center={{
                lat: this.state.map_region_properties.center.latitude,
                lng: this.state.map_region_properties.center.longitude
              }}
              zoom={this.state.map_region_properties.zoom}
              onZoomAnimationEnd={zoom => {
                this.setState({
                  map_region_properties: {
                    ...this.state.map_region_properties,
                    zoom: zoom
                  }
                });
              }}
              options={{
                ...getMapOptions(
                  this.props.map_type,
                  this.props.dark_mode === "dark_mode" ? true : false,
                  false
                ),
                gestureHandling: this.props.is_drawing ? "none" : "greedy"
              }}
              onGoogleApiLoaded={({ map, maps }) => {
                this.onMapReady(map, maps);
              }}
              onClick={e => {
                if (e) {
                  if (this.props.is_drawing) {
                    //place pin on map
                    this.props.addDrawingCoordinate({
                      latitude: e.lat,
                      longitude: e.lng
                    });
                  } else {
                    //place pin on map
                    this.updatePinLocation({
                      latitude: e.lat,
                      longitude: e.lng
                    });
                  }
                }
              }}
              onChange={({ center, bounds }) => {
                if (center) {
                  const longitudeDelta = Math.abs(
                    bounds.se.lng - bounds.nw.lng
                  );
                  const latitudeDelta = Math.abs(bounds.se.lat - bounds.nw.lat);

                  this.props.updateMapLocation({ coordinates: null });
                  this.props.setLastLocation({
                    coordinates: {
                      latitude: center.lat,
                      longitude: center.lng
                    }
                  });

                  this.setState({
                    map_region_properties: {
                      ...this.state.map_region_properties,
                      center: {
                        latitude: center.lat,
                        longitude: center.lng
                      },
                      latitudeDelta: latitudeDelta,
                      longitudeDelta: longitudeDelta
                    }
                  });
                }
              }}
              onDrag={map => {
                this.updatePinLocation(null);
                this.toggleIsPanDraging(true);
              }}
              onDragEnd={() => {
                this.toggleIsPanDraging(false);
              }}
              //draggable={!this.props.lock_location_tracking}
              mapTypeId={this.props.map_type}
            >
              {this.renderMapPin(this.state.pin_location)}

              {this.props.drawing_coordinates.map((coordinate, i) => {
                return (
                  <div
                    lat={coordinate.latitude}
                    lng={coordinate.longitude}
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 10,
                      backgroundColor: this.props.colors.card_color,
                      borderColor: this.props.colors.success_color,
                      borderWidth: 3,
                      borderStyle: "solid",
                      marginTop: -5,
                      marginLeft: -5
                    }}
                    onClick={e => {
                      //fix for android
                      if (e.nativeEvent) {
                        if (i === 0) {
                          this.props.expandMap(false);
                          this.props.completeDrawing();
                        }
                      }
                    }}
                  />
                );
              })}
            </GoogleMapReact>
          </div>
          {/* more stuff here*/}
          <DrawingMapHeader
            handleZoomControl={this.handleZoomControl.bind(this)}
            {...this.props}
          />
          <DrawingMapFooter {...this.props} />
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, drawer, settings, native, property_map }) => {
  const { token, user } = auth;
  const { open } = drawer;
  const { dark_mode, colors } = settings;
  const { window_width, window_height, isMobile } = native;
  const { update_map_location, last_location } = property_map;

  return {
    token,
    user,
    open,
    dark_mode,
    colors,
    window_width,
    window_height,
    isMobile,

    update_map_location,
    last_location
  };
};

export default connect(mapStateToProps, {
  updateMapLocation,
  setLastLocation
})(DrawMap);
